import React, { Component, Fragment } from 'react';
import api, { apiErrorHandler, apiResponseHandler } from '../../services/AxiosService';
import { Redirect, withRouter, Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import authService from '../../services/AuthService';
import ClinicianInfo from './ClinicianInfo';
import AssessmentSearch from './AssessmentSearch';
import AssessmentResults from './AssessmentResults';
import cadeHeader from '../../content/CADEAIHeader.png';
import '../../index.css';
import './Home.css';

import Tour from '../../productTour/Tour';
import tourDef from '../../productTour/TourDef';
import { apiErrorPopup } from '../../helpers/MessagePopup';

const logoPath = "/content/CorbettLogo.png";


/*
 * Home is responsible for allowing the user to select an assessment (by FN, LN, Birthdate) and the routing to CADE.
 */

class Home extends Component {
    _isMounted = false;     // We don't want to setState in a promise if this component doesn't mount.  This flag is used for catch that
    constructor(props) {
        super(props);

        this.state = {
            organizationName: null,
            organizationLogo: null,
            userDisplayName: null,
            personFirstName: this.props.personFirstName,
            personLastName: this.props.personLastName,
            personBirthDate: this.props.personBirthDate,
            providerId: this.props.providerId,
            totalPersonsAssessed: 0,
            totalAssessments: 0,
            personAssessments: this.props.personAssessments,
            personList: props.personList,
            searchMessage: props.searchMessage,
            personSortOrder: props.personSortOrder
        }
    }

    assessmentCreationHandler = (fn, ln, bd, providerId) => {
        this.props.assessmentCreationHandler(fn, ln, bd, providerId);
    }

    assessmentSearchHandler = (fn, ln, bd, providerId) => {
        // Call the api to get a list of assessments associated with this person.  URL encode the person's name and bd (with the slashes removed from the bd using regEx since replace only replaces first occurance)
        let fnLnBd = fn + ln + bd.replace(/\//g, '');
        let encPerson = encodeURIComponent(fnLnBd);
        providerId = providerId

        // Don't include archived assessments
        let ia = 0;
        let url = "account/" + authService.authenticatedUserId + "/assessments/" + encPerson + "/provider/" + providerId + "/ia/" + ia + "/aun/" + authService.authenticatedUserName;

        api.get(url, {
            headers: {
                Authorization: 'Bearer ' + authService.token
            }
        })
        .then(response => {
            if (response.status == 200) {
                this.props.personSearchHandler(fn, ln, bd, response.data.assessments, response.data.providerId, null);
            }
            else {
                apiErrorPopup(apiResponseHandler(response));
            }
        })
        .catch(error => {
            apiErrorPopup (apiErrorHandler(error));
        });
    }

    componentWillMount() {
        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;
        // Run a query and get the current user info and stats.
        let url = "account/" + authService.authenticatedUserId;
        api.get(url, {
            headers: {
                Authorization: 'Bearer ' + authService.token 
            }
        })
        .then(response => {
            if (response.status == 200) {

                if (this._isMounted) {
                    // Retain authenticated user information in state.
                    this.setState({
                        userDisplayName: response.data.displayName,
                        organizationName: response.data.organizationName,
                        totalAssessments: response.data.totalAssessments,
                        totalPersonsAssessed: response.data.totalPersonsAssessed
                    })
                }
            }
            else {
                // Major problem - should not happen.  Back to login
                alert("Sorry...Something has gone wrong. Please login again.");
                authService.setAuthenticated(null, null, 0, null, null, null, null, false, false, false, false, false, -1, null);
                if (this._isMounted) {
                    this.setState({
                        organizationName: "Unknown"

                    })
                }
            }
        })
        .catch(error => {
            // Major problem - should not happen.  Back to login
            authService.setAuthenticated(null, null, 0, null, null, null, null, false, false, false,false, false, -1, null);
            if (this._isMounted) {
                this.setState({
                    organizationName: "Unknown"
                })
            }
        });
    }

    personSortHandler = (sortOrder) => {
        this.state.personSortOrder = sortOrder; // Don't want a state change.
        this.props.personSortOrderHandler(sortOrder);
    }

    render() {
        // Ensure user is authenticated or boot them to login page
        if (!authService.isAuthenticated) {
            return (<Redirect to='/' />);
        }

        let isRaterOrCaregiver = authService.isCaregiverOrRater;
        let isCaregiver = authService.isCaregiver;
        let isParent = authService.isParentAccount;
        let partnerRole = authService.partnerRole;

        return (
            <div>
                <Fragment>
                    <Tour
                        name="Home"
                        key="new Date()"
                    />
                    <Container>
                        <img src={logoPath} width="50" height="auto" className="home_cadeLogo tour_homeCadeLogo" alt="CADE Header" />

                        {!isRaterOrCaregiver &&
                            <span className="home_ProfileDropdown tour_homeProfile">
                                <DropdownButton title={this.state.userDisplayName} variant="secondary" alignRight>
                                    <Link to={{
                                        pathname: '/gettingstarted'
                                    }}>
                                    <Dropdown.Item as="button">Getting Started</Dropdown.Item>

                                </Link>

                                    <Link to={{
                                        pathname: '/profile',
                                        state: {
                                            userDisplayName: this.state.userDisplayName,
                                            tabToDisplay: "generalTab"
                                        }
                                    }}>
                                        <Dropdown.Item as="button">Profile</Dropdown.Item>
                                    </Link>
                            
                                    <Link to={{
                                        pathname: '/'
                                    }}>
                                        <Dropdown.Item as="button">Logout</Dropdown.Item>
                                    </Link>
                                </DropdownButton>
                            </span>
                        }
                        {isRaterOrCaregiver &&
                            <span className="home_ProfileDropdown tour_homeProfile">
                            <DropdownButton id="profileDropdown" title="Guest" variant="info" alignRight>
                                <Link to={{
                                    pathname: '/'
                                }}>
                                    <Dropdown.Item as="button">Logout</Dropdown.Item>
                                </Link>
                                </DropdownButton>
                            </span>
                        }
                        <Row className="tour_home">
                            {!isRaterOrCaregiver && !isParent &&
                                <ClinicianInfo
                                    organizationName={this.state.organizationName}
                                    organizationLogo={this.state.organizationLogo}
                                    userDisplayName={this.state.userDisplayName}
                                    totalAssessments={this.state.totalAssessments}
                                    totalPersonsAssessed={this.state.totalPersonsAssessed}
                                    isCaregiverOrRater={isRaterOrCaregiver}
                                />
                            }
                        </Row>
                        
                        <Row>
                            <Col sm={12}>
                                <AssessmentSearch
                                    firstName={this.state.personFirstName}
                                    lastName={this.state.personLastName}
                                    userDisplayName={this.state.userDisplayName}
                                    birthDate={this.state.personBirthDate}
                                    providerId={this.state.providerId}
                                    isCaregiverOrRater={isRaterOrCaregiver}
                                    isCaregiver={isCaregiver}
                                    partnerRole={partnerRole}
                                    personList={this.state.personList}
                                    personAssessments={this.state.personAssessments}
                                    searchMessage={this.state.searchMessage}
                                    personSortOrder={this.state.personSortOrder}
                                    personSortHandler={this.personSortHandler}
                                    assessmentCreationHandler={this.assessmentCreationHandler}
                                    assessmentSearchHandler={this.assessmentSearchHandler}
                                    assessmentSelectionHandler={this.props.assessmentSelectionHandler}
                                    assessmentDeleteHandler={this.props.assessmentDeleteHandler}
                                    assessmentCopyHandler={this.props.assessmentCopyHandler}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12}>
                                <br />
                            </Col>
                        </Row>
                    
                        </Container>
                </Fragment>
            </div>
        );

    }
}

export default withRouter(Home);


// WEBPACK FOOTER //
// ./src/components/Home/Home.js